const getAssessmentWalkthroughObject = () => {
  return {
    headingTextColor: "#000000DE",
    textColor: "#00000099",
    getStarted: { color: "#0D47A1", fontSize: "14px" },
    checkbox: {
      width: "14px",
      height: "14px",
      marginRight: "10px",
      color: "black",
      "&.Mui-checked": {
        color: "#0D47A1",
      },
    },
    bottomDiv: {
      padding: "8px 27px !important",
      display: "flex",
    },
  };
};

export const getAssessmentWalkthroughStyle = getAssessmentWalkthroughObject;
